export const fetchJsonAds = async (object, num, chash, show_id, utm_term) => {
    if (!object) {
        return { news: [], billingNoticeUrl: null };
    }
    try {
        let url = `https://ssp.24smi.net/rtb/v2/ad?object=${object}&output=json&num=${num}&chash=${chash}&show_id=${show_id}`;
        if (utm_term) {
            url += `&subid_source=${encodeURIComponent(utm_term)}`;
        }
        const response = await fetch(url);
        if (response.status === 204) {
            return { news: [], billingNoticeUrl: null };
        }
        const data = await response.json();
        const news = Array.isArray(data.news) ? data.news.map(teaser => ({
            ...teaser,
            _ssp_source: true,
            _ssp_chash: chash
        })) : [];
        if (news.length) {
            var hasBidder6 = news.some(function(teaser) { return teaser.bidder_id === 6; });
            if (!hasBidder6) {
                console.log('[fetchJsonAds] no teasers with bidder_id=6, bidder_ids:', news.map(function(t) { return t.bidder_id; }));
            }
            news.forEach(function(teaser) {
                if (teaser.bidder_id === 6) {
                    console.log('[fetchJsonAds] bidder_id=6 teaser', teaser);
                }
            });
        }
        return {
            news,
            billingNoticeUrl: data.settings && data.settings.billingNoticeUrl
        };
    } catch (error) {
        console.error('Error fetching the data:', error);
        return {
            news: [],
            billingNoticeUrl: null
        };
    }
}
